// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const defaultMarkerTop = "-5px";
export const textCenter = "CreditChart__textCenter__-VCKL";
export const creditChart = "CreditChart__creditChart__ZDZH2";
export const creditBarPortion = "CreditChart__creditBarPortion__XUpoi";
export const creditBarLabels = "CreditChart__creditBarLabels__bxLdL font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const low = "CreditChart__low__vEsgG";
export const fair = "CreditChart__fair__nYCS5";
export const good = "CreditChart__good__DlduQ";
export const great = "CreditChart__great__jgjvl";
export const excellent = "CreditChart__excellent__ZKxqt";
export const creditMarker = "CreditChart__creditMarker__jXDlF";
export const tooltipContainer = "CreditChart__tooltipContainer__QmsCY";
export const member = "CreditChart__member__QaiYz";
export const peers = "CreditChart__peers__MmsKr";
export const others = "CreditChart__others__Ye83T";